//
// Abra - Product
// Isolated from abra.js to improve Recharge 2.0 widget

(() => {
  if (!window.location.pathname.includes('/products')) return;
  
  const process = () => {
    for (let el of document.querySelectorAll('*')) {
      if (!el.shadowRoot) continue;
      
      const subscribePrice = el.shadowRoot.querySelector('.rc-purchase-option__subscription .rc-purchase-option__prices');
      const buyOncePrice = el.shadowRoot.querySelector('.rc-selection__onetime .rc-purchase-option__prices');
      
      if (subscribePrice && !subscribePrice.classList.contains('subscribe-opt')) {
        subscribePrice.classList.add('subscribe-opt');
      }
      
      if (buyOncePrice && !buyOncePrice.classList.contains('buy-once-opt')) {
        buyOncePrice.classList.add('buy-once-opt');
      }
      
      if ((subscribePrice || buyOncePrice) && window.Abra) {
        window.Abra.useSellingPlanPriceOnProductBlock = true;
        window.Abra.render();
        return true;
      }
    }
    return false;
  };

  let attempts = 0;
  const interval = setInterval(() => {
    if (process() || ++attempts >= 20) clearInterval(interval);
  }, 200);
  
  new MutationObserver(() => setTimeout(process, 100)).observe(document.body, {childList: true, subtree: true});
})();

console.log("SCRIPT_LOAD: abra-product.js");